import { useState } from "react";
import Datatable from "../../../../components/Datatable/Datatable";
import peticionBack from "../../../../libs/peticiones/peticionBack";
import { toaster } from "rsuite";
import createURL from "../../../../libs/peticiones/url";
import { getFileNameFromSrc } from "../../../../libs/formats";
import { Report } from "../../../../enums/Report";

export default function Archivos({ report, openT }: { report: any ,openT: boolean }) {
    const [refresh, setRefresh] = useState<boolean>(false);

    async function getData(order: string, records: number, page: number, search: string) {
        const url = createURL(`/reportes/${Report.FILE}`, [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
            { name: "rows", value: "_id,folder,propietary,tag,src" },
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }

    /* TABLA */
    const columns = [
        { data: "src", render: (data: string) => getFileNameFromSrc(data) },
        { data: "folder", render: (f: any) => <p>{f.name}</p> },
        { data: "propietary", render: (p: any) => <p>{p?.fullname || "Sin propietario"}</p> },
        { data: "tag"},
        { data: "src" },
    ];

    const columnDefs = [
        { className: "text-center", targets: [0, 1, 2, 3, 4] },
    ];

    return (
        <>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Archivos</h4>
            </div>
            <Datatable
                columns={columns}
                headers={["Nombre del archivo", "Folder", "Propietario ", "Tag", "Ruta"]}
                columnDefs={columnDefs}
                petition={getData}
                control="back"
                stateRefresh={[refresh, setRefresh]}
                className="p-0"
            />
        </>
    );
}